"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ScopeGuard_1 = __importDefault(require("../../common/js/components/security/ScopeGuard"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const AuthorizedLink = ({ audience, children, className, href, scopes, target = '_blank', }) => (react_1.default.createElement(ScopeGuard_1.default, { scopes: scopes, fallback: react_1.default.createElement(react_1.default.Fragment, null, children) },
    react_1.default.createElement("a", { className: className, href: "#", onClick: (event) => {
            event.preventDefault();
            AuthorizationStore_1.default.auth0
                ?.getAccessTokenSilently({ audience, scope: ['email', ...scopes].join(' '), ignoreCache: false })
                .then((accessToken) => {
                const url = new URL(href);
                url.searchParams.set('bearer', accessToken);
                window.open(url, target);
            });
        } }, children)));
exports.default = AuthorizedLink;
